import ModalContainer from "../../../ModalContainer";
import React from "react";
import img from "../../../../assets/images/abroadImg.svg"
import "./welcome-abroad.scss"

type Props = {
    isOpen: boolean;
    close: () => void;
}

export const WelcomeAboard: React.FC<Props> = ({ isOpen, close }) => {
    return (
        <div className={"welcome-abroad__container"}>
            <ModalContainer isOpen={isOpen} close={close}>
                <div className={"welcome-abroad"}>
                    <h4>Welcome to your account!</h4>
                    <img src={img} alt=""/>
                    <h2>Welcome aboard! </h2>
                    <p>
                        Your account is set up and ready to go. <br />
                        Let's explore what you can do here.
                    </p>
                    <button onClick={close} className={"btn-black w100 text-uppercase mt25"}>Show me around</button>
                </div>
            </ModalContainer>
        </div>
    )
}